import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import CaptureGroupEventCodeSnippet from "../_snippets/capture-group-event-code.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Groups must be created before events can be associated with them.`}</p>

    <CaptureGroupEventCodeSnippet mdxType="CaptureGroupEventCodeSnippet" />
    <p>{`In the above example, we create a group type `}<inlineCode parentName="p">{`company`}</inlineCode>{`. Then, for each company, we set the `}<inlineCode parentName="p">{`group key`}</inlineCode>{` as the unique identifier for that specific company. This can be anything that helps you identify it, such as ID or domain.`}</p>
    <p>{`We now have one `}<inlineCode parentName="p">{`company`}</inlineCode>{`-type group with a key `}<inlineCode parentName="p">{`company_id_in_your_db`}</inlineCode>{`. When we send the event `}<inlineCode parentName="p">{`user_signed_up`}</inlineCode>{`, it will be attached to this newly created group.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Tips:`}</strong></p>
      <ul parentName="blockquote">
        <li parentName="ul">{`When specifying the group type, use the singular version for clarity (`}<inlineCode parentName="li">{`company`}</inlineCode>{` instead of `}<inlineCode parentName="li">{`companies`}</inlineCode>{`).`}</li>
        <li parentName="ul">{`We advise against using the `}<em parentName="li">{`name`}</em>{` of the company (or any other group) as the key, because that's rarely guaranteed to be unique, and thus can affect the quality of analytics data. Use a unique string, like an ID.`}</li>
      </ul>
    </blockquote>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Group type limit:`}</strong>{` There's a hard limit of 5 group types within PostHog, although within each group type you can have an unlimited number of groups.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      